require('../../../lib/mmenu-light/dist/mmenu-light');

document.addEventListener('DOMContentLoaded', function() {

    /**
     * Navigation related
     */
    const menu = new MmenuLight(
        document.querySelector( "#navbarSupportedContent" ),
        "(max-width: 1024px)"
    );

    const navigator = menu.navigation({
        theme: 'light'
    });

    const drawer = menu.offcanvas();
    
    document.querySelector( "a[href='#menu']" ).addEventListener( "click", ( event ) => {
        event.preventDefault();
        drawer.open();
    });



    document.addEventListener('mouseover', (event) => {

        if (event.target.classList.contains('dropdown-item') || event.target.classList.contains('dropdown')) {
            let parts;
            if (event.target.classList.contains('dropdown')) {
                parts = event.target.querySelectorAll('.subnav-part');
                event.target.classList.add('open');
            } else {
                parts = event.target.parentNode.querySelectorAll('.subnav-part');
                event.target.parentNode.classList.add('open');
            }

            let height = 0;
            parts.forEach((part) => {
                if (part.offsetHeight > height) {
                    height = part.offsetHeight;
                }
            });
            if (height === 0) {
                return true;
            }
            document.documentElement.style.setProperty('--dropdown-height', parseInt(height + 65) + 'px');

            if(window.matchMedia("(min-width: 1025px)").matches) {
                document.documentElement.style.setProperty('--scrolled-dropdown-distance', parseInt(window.pageYOffset) + 'px');
            }

        }
    });

    if (document.querySelectorAll('.dropdown')) {
        document.querySelectorAll('.dropdown').forEach((element) => {
            element.addEventListener('mouseleave', (event) => {
                if (event.target.classList.contains('open')) {
                    event.target.classList.remove('open');
                }
            });
        });
    }

    document.addEventListener('mouseleave', (event) => {
        if (event.target.hasOwnProperty('classList') && event.target.classList.contains('open')) {
            document.querySelector('.dropdown.open').classList.remove('open');
        }

    });

    window.addEventListener('scroll', (event) => {
        if (document.querySelector('.dropdown.open')) {
            document.querySelector('.dropdown.open').classList.remove('open');
        }
    });
});